<template>
  <div class="grid sm:grid-cols-2 lg:h-full">
    <div class="bg-section_s1 order-2 lg:order-1"></div>
    <div class="flex justify-center items-center bg-white order-1 lg:order-2">
      <div
        class="text-center last:xl:text-left xl:py-10 px-5 py-14 lg:py-2 xl:px-28 w-full"
      >
        <img
          src="@/assets/img/hike-variant-1.png"
          class="logo_main_sc1 mx-auto xl:mx-0"
          alt="Hike Society"
        />
        <p
          class="subtitle-info mt-5 leading-5 lg:leading-6 text-lg lg:text-md text-justify"
        >
          <b>Hike Society</b> es más que una comunidad, es el punto de encuentro
          para quienes aman la naturaleza y el aire libre. A través de nuestras
          experiencias de senderismo, te invitamos a explorar paisajes
          impresionantes, recorrer senderos y conectar con personas que
          comparten tu pasión por la aventura. Nuestro propósito es brindarte un
          espacio donde cada ruta se convierta en una oportunidad única.
        </p>
        <p class="mt-5 leading-5 lg:leading-6 text-lg lg:text-md text-justify">
          En estas experiencias, compartiremos con expertos en senderismo y
          montaña pero tambien con aficionados, que entre todos crearemos
          momentos épicos que desafíen tus límites.
        </p>
        <p class="mt-5 leading-5 lg:leading-6 text-lg lg:text-md text-justify">
          Sin importar si eres principiante o un senderista experimentado en
          Hike Society encontrarás una comunidad que te motivará a seguir
          explorando y conociendo más sobre las actividades al aire libre.
        </p>
        <p class="mt-5 leading-5 lg:leading-6 text-lg lg:text-md text-justify">
          ¡Preparate y vive esta aventura con nosotros!
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.logo_main_sc1 {
  width: 100%;
  max-width: 420px;
  height: auto;
}
.bg-section_s1 {
  background-image: url("@/assets/img/bg-s1.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 50vh;
}

@media screen and (min-width: 640px) {
  .bg-section_s1 {
    min-height: 100%;
  }
}

@media screen and (max-width: 639px) {
  .bg-section_s1 {
    background-position: 65% center;
  }
}
</style>
